import { Action, ConsentCookies, CookieMethod, ErrorCodes, OperationType, ThemeLoad } from "puzzle";

export const getPreferencesThemes: Action = [{
  load: ThemeLoad.init,
  type: OperationType.theme
}];
export const getPreferencesLanguagesAndData: Action = [{
  data: {
    isRest: false,
    method: 'get',
    url: '/locales/list.json'
  },
  mappingName: 'languages',
  type: OperationType.request
}];
export const loadPreferencesData: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  name: 'userPromise',
  type: OperationType.action
}, {
  name: 'getPreferencesThemes',
  type: OperationType.action
}, {
  name: 'getPreferencesLanguagesAndData',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        isSsoUser: '{initializeUserData.userProfile.userInfo.isSsoUser}'
      }
    }
  },
  type: OperationType.data
}, {
  moduleName: 'Preferences',
  name: 'setPreferencesData',
  args: ['languages', 'preferencesData', 'themes', 'isSsoUser'],
}, {
  persistent: ['themes'],
  type: OperationType.removePersistentData
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const saveAndUpdatePreference: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  name: 'savePreference',
  type: OperationType.action
}, {
  name: 'updatePreference',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}, {
  moduleName: 'ToastNotifications',
  name: 'createPreferenceNotifications'
}];

export const savePreference: Action = [{
  moduleName: 'EmailPreference',
  name: 'getDataForSave',
  args: ['preferencesFormData'],
  mappingName: 'preferencesFormData',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      method: 'put',
      url: '/preferences',
      bind: {
        params: '{preferencesFormData}'
      }
    },
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'savePreferenceResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{savePreferenceResponse}',
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}];

export const changeLanguageFromHeader: Action = [{
  name: 'checkboxSelectionClear',
  type: OperationType.action
}, {
  data: {
    template: {
      method: 'put',
      url: '/preferences',
      bind: {
        params: '{languagePreferencesData}'
      }
    },
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'savePreferenceResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{savePreferenceResponse}',
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  name: 'changeLanguageInApp',
  type: OperationType.action
}, {
  name: 'getAndPreservePreferenceData',
  type: OperationType.action
}, {
  name: 'reloadPathPD',
  type: OperationType.action
}];

export const changeLanguageInApp: Action = [{
  moduleName: 'App',
  name: 'setDocumentLanguage',
  args: ['selectedLanguage']
}, {
  args: ['selectedLanguage'],
  moduleName: 'App',
  name: 'setupDayjsLocale'
}, {
  data: {
    template: {
      bind: {
        locale: '{selectedLanguage}'
      }
    }
  },
  change: true,
  type: OperationType.language
}, {
  data: {
    template: {
      bind: {
        name: '{localeCookieName}',
        value: '{locale}'
      }
    }
  },
  args: ['name', 'value'],
  cookieType: ConsentCookies.functional,
  method: CookieMethod.setCookie,
  type: OperationType.cookie
}, {
  name: 'getChildLocalization',
  type: OperationType.action
}];

export const updatePreference: Action = [{
  name: 'getAndPreservePreferenceData',
  type: OperationType.action
}, {
  moduleName: 'EmailPreference',
  name: 'updateSavedEmailPreference',
  args: ['preferencesData'],
  type: OperationType.addOperationData
}, {
  condition: '{themeChanged}',
  conditionOperations: [{
    condition: '{theme}',
    conditionOperations: [{
      data: {
        template: {
          bind: {
            name: '{themeCookieName}',
            value: '{theme}'
          }
        }
      },
      args: ['name', 'value'],
      cookieType: ConsentCookies.functional,
      method: CookieMethod.setCookie,
      type: OperationType.cookie
    }],
    type: OperationType.conditional
  }, {
    load: ThemeLoad.change,
    type: OperationType.theme
  }],
  type: OperationType.conditional
}, {
  condition: '{languageChanged} && {selectedLanguage}',
  conditionOperations: [{
    name: 'changeLanguageInApp',
    type: OperationType.action
  }, {
    args: ['locale'],
    name: 'updatePreviousLanguage',
    moduleName: 'Preferences'
  }, {
    name: 'setCurrentLocale',
    moduleName: 'ChangeLanguage',
    args: ['selectedLanguage']
  }],
  type: OperationType.conditional
}, {
  moduleName: 'Preferences',
  name: 'updateDueSoonOnDispatcher',
  args: ['initializeUserData'],
  mappingName: 'newInitializeUserData',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        initializeUserData: '{newInitializeUserData}'
      }
    }
  },
  persistent: ['initializeUserData'],
  type: OperationType.addPersistentData
}, {
  data: {
    template: {
      bind: {
        theme: '{preferencesFormData.theme}'
      }
    }
  },
  args: ['theme'],
  moduleName: 'Header',
  name: 'setTheme'
}]

